import {
  mapActions,
  mapMutations,
  mapState,
} from 'vuex'

import { SET_ITEM, ADD_ITEM_TO_LIST } from '@/store/api-models/core/mutation-types'

export default {
  computed: {
    ...mapState({
      places: state => state.apiModels.place.list,
      place: state => state.apiModels.place.item,
    }),
  },
  methods: {
    ...mapActions({
      findPlace: 'apiModels/place/get',
    }),
    ...mapMutations({
      commitPlace: `apiModels/place/${SET_ITEM}`,
      addPlace: `apiModels/place/${ADD_ITEM_TO_LIST}`,
    }),
    pushPlaceToStore(model) {
      this.commitPlace(model)

      if (model) {
        this.addPlace(model)
      }
    },
    loadPlace(id) {
      const params = {
        id,
      }

      this.findPlace(params)
        .then(place => {
          this.afterFindPlace(place)
        })
    },
    afterFindPlace() {
    },
  },
}
